import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=19aa2b70&scoped=true&"
import script from "./CardInfo.vue?vue&type=script&lang=ts&"
export * from "./CardInfo.vue?vue&type=script&lang=ts&"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=19aa2b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa2b70",
  null
  
)

export default component.exports